/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class NotificationReportResponse {
    getFixupPrototypeFunction() { return NotificationReportResponse.fixupPrototype; }

    static newInstance(model: Partial<NotificationReportResponse>): NotificationReportResponse {
        let obj = Object.assign(new NotificationReportResponse(), model);
        NotificationReportResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<NotificationReportResponse>): NotificationReportResponse {
        if (!model) return null;
        return NotificationReportResponse.newInstance(<NotificationReportResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: NotificationReportResponse) {
        if (!obj) return;

        models.NotificationReportResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: NotificationReportResponse): boolean {
        Object.setPrototypeOf(obj, NotificationReportResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Result status
     */
    status: string;

    /**
     * Result message
     */
    message: string;

}
